"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const S3UploaderRepository_1 = tslib_1.__importDefault(require("../repositories/S3UploaderRepository"));
class S3Uploader {
    defaults() {
        return {
            file: null,
            url: '',
        };
    }
    save(key, operation) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const s3UploaderRepository = new S3UploaderRepository_1.default();
            const signUrl = yield s3UploaderRepository.getSignUrl(key, operation);
            const { ok, url } = yield fetch(signUrl, {
                method: 'PUT',
                body: this.file,
            });
            if (ok) {
                this.url = url;
            }
        });
    }
    remove(key) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const s3UploaderRepository = new S3UploaderRepository_1.default();
            const { signUrl } = yield s3UploaderRepository.getSignUrl(key, 'deleteObject');
            const { ok, url } = yield fetch(signUrl, {
                method: 'DELETE',
            });
            if (ok) {
                this.url = url;
            }
        });
    }
}
exports.default = S3Uploader;
//# sourceMappingURL=S3Uploader.js.map